
__webpack_require__.debugRequireIds = {
	"-!./debug-require.cjs": 2800,
	"./debug-require.cjs": 80418,
	"./src/base_page_params.ts": 80371,
	"./src/blueslip.ts": 7717,
	"./src/blueslip_stacktrace.ts": 51761,
	"./src/bot_types.ts": 41548,
	"./src/bundles/common.ts": 16004,
	"./src/bundles/legacy_portico_bundle.ts": 96032,
	"./src/csrf.ts": 60737,
	"./src/loading_error.ts": 88794,
	"./src/portico/google-analytics.ts": 74024,
	"./src/portico/legacy_header.ts": 56717,
	"./src/portico/portico_modals.ts": 99289,
	"./src/portico/tippyjs.ts": 2533,
	"./src/realm_user_settings_defaults.ts": 95387,
	"./src/retry_backoff.ts": 74798,
	"./src/sentry.ts": 8308,
	"./src/state_data.ts": 63809,
	"./src/stream_types.ts": 51709,
	"./src/types.ts": 98826,
	"./src/user_settings.ts": 44514,
	"./src/user_status_types.ts": 96075,
	"./styles/portico/collaborychat_auth.css": 74197,
	"./templates/blueslip_stacktrace.hbs": 97825,
	"@sentry/conventions/attributes": 59966,
	"core-js/modules/es.array.includes.js": 66326,
	"core-js/modules/es.array.push.js": 97211,
	"core-js/modules/es.iterator.constructor.js": 86074,
	"core-js/modules/es.iterator.find.js": 65919,
	"core-js/modules/es.iterator.map.js": 33520,
	"core-js/modules/es.json.parse.js": 56133,
	"core-js/modules/es.json.stringify.js": 28987,
	"core-js/modules/es.map.get-or-insert-computed.js": 346,
	"core-js/modules/es.map.get-or-insert.js": 88536,
	"error-stack-parser": 69363,
	"ga-gtag": 78406,
	"handlebars/runtime.js": 38417,
	"jquery": 63150,
	"micromodal": 94456,
	"minimalistic-assert": 45185,
	"source-map": 68068,
	"stackframe": 36854,
	"stacktrace-gps": 14021,
	"tippy.js": 99947,
	"tippy.js/dist/tippy.css": 26798
};